import { h, t } from './dom.js';
import { waitProgress } from './progress.js';

const TICK_MS = 500;

export interface WaitStep {
  /** The block in strings.de.json: h1, h1_bold, h1_end, lead, aria, note. A blank lead or note drops the line. */
  strings: string;
  id: string;
  barId: string;
  /** The usual duration of the call. It sends no events, so the bar follows the time against it. */
  expectedMs: number;
}

/** A wait on a model call, a step of its own: what was on screen has left, nothing here can be pressed, a title
 * says what we do, a bar shows that the wait is under way, one line says how long it takes. */
export function renderWait(step: WaitStep): HTMLElement {
  const s = (key: string) => t(`${step.strings}.${key}`);
  const root = h('section', { class: 'stage on wait', id: step.id });
  root.append(h('h1', {}, `${s('h1')} `, h('b', {}, s('h1_bold')), s('h1_end') ? ` ${s('h1_end')}` : ''));
  if (s('lead')) root.append(h('p', { class: 'lead' }, s('lead')));
  const fill = h('i');
  const bar = h('div', { class: 'bar', id: step.barId, role: 'progressbar', 'aria-label': s('aria'), 'aria-valuemin': 0, 'aria-valuemax': 100, 'aria-valuenow': 0 }, fill);
  root.append(bar);
  if (s('note')) root.append(h('p', { class: 'later' }, s('note')));

  const started = performance.now();
  const paint = () => {
    // The stylesheet moves the bar to a new width within one tick, so each tick aims at where the wait stands by then.
    const value = waitProgress(performance.now() - started + TICK_MS, step.expectedMs);
    fill.style.width = `${value.toFixed(1)}%`;
    bar.setAttribute('aria-valuenow', String(Math.round(value)));
  };
  // Ends with the step leaving the page: the answer is there, or the request failed.
  const timer = window.setInterval(() => {
    if (root.isConnected) paint();
    else window.clearInterval(timer);
  }, TICK_MS);
  // One frame with an empty bar first, so the first stretch is a movement too.
  requestAnimationFrame(() => requestAnimationFrame(paint));
  return root;
}
